<template>
    <div class="interface-content">

        <!-- Interface Header -->
        <div class="interface-header" v-if="!noHeader">

            <!-- Button Event -->
            <b-button variant="success" v-if="btnAction" @click="event(btnAction)">
                <i class="material-icons">{{ btnAction.options.btnIcon || 'add' }}</i>
            </b-button>

            <!-- Filter -->
            <span v-if="!noFilter" @click="filterSwitch" :class="'filter' + (filter ? ' actived' : '')">
                <i class="material-icons-outlined">filter_alt</i>
                Filtro<!--
            --></span>

            <!-- if Filter && OrderBy -->
            <span v-if="!noFilter" class="v-separator"></span>

            <!-- Order By -->
            <span v-if="!noOrder" class="orderby">Ordenar por</span>
            <b-form-select
                v-if="!noOrder"
                id="sort-by-select"
                @change="orderByChange"
                :options="sortOptions"
                v-model="sortBy"
                class="select"
            >
                <template #first>
                    <option value="">-- Nenhum campo selecionado --</option>
                </template>
            </b-form-select>

            <!-- Line Separator -->
            <HLine :label="lineLabel" class="mt-4"></HLine>

        </div>

        <!-- Slot Content -->
        <div class="slot-content">
            <slot></slot>
        </div>

    </div>
</template>

<script>

/**
 * Component Holder - Interface
 *
 * Slot for content, has a header with a button event, a filter toggle
 * and a select for order by as static events
 *
 * Events:
 *   - Button on header in left (no suffix needed)
 *       + Options:
 *           - btnIcon(String) default 'add'
 *
 * Static Events:
 *   - Toggle Filter 'filter'
 *   - Select Order by 'sort'
 *
 * Props:
 *   - Display header 'noHeader' default 'false'
 *       + if true no events will be trigger as well as header not shown
 *   - Order by Options 'sortOptions' not required
 *       + if not pass orderby will not be shown
 *   - Line separator label 'lineLabel' not required
 *       + 'noHeader' must be false to Line separator be shown
 *
 *  Obs: add more fields case additional customization are needed
 */

import Action from '@/mixins/core/ActionBehavior'
import Event from '@/mixins/core/EventBehavior'

import HLine from '@/components/static/Line'

export default {
  mixins: [Action, Event],
  components: { HLine },
  data: () => ({
    actionsScope: 'Interface',
    sortBy: '',
    filter: false
  }),
  props: {
    noHeader: { type: Boolean, default: false },
    noFilter: { type: Boolean, default: false, required: false },
    noOrder: { type: Boolean, default: false, required: false },
    sortOptions: { type: Array, required: false },
    lineLabel: { type: String, required: false }
  },
  methods: {
    filterSwitch () {
      this.filter = !this.filter
      this.$emit('filter', this.filter)
    },
    orderByChange (e) {
      this.$emit('sort', e)
    }
  },
  computed: {
    btnAction () {
      return this.actions[0]
    }
  }
}
</script>

<style lang="stylus" scoped>

    @import '../../style/colors.styl';
    @import '../../style/fonts.styl';
    @import '../../style/mixins.styl';
    @import '../../style/spacing.styl';

    .title-btn
        float right
        background-color accent
        color white
        border-radius radius-md
        padding space-sm space-md
        cursor pointer
        transition all transition-base

        &:hover
            background-color primary

    .interface-content
        background-color secondary
        padding space-md space-md space-md 0
        border-radius radius-lg
        color color-theme(true)

        .interface-header
            padding space-md
            display flex
            flex-wrap wrap
            align-items center
            gap space-sm

            span
                font-size 1.1rem
                vertical-align middle

            .filter
                cursor pointer
                display inline-flex
                align-items center
                gap space-xs
                padding space-xs space-sm
                border-radius radius-md
                transition all transition-base

                &:hover
                    color primary
                    background-color rgba(255, 140, 66, 0.1)

            .actived
                color primary
                background-color rgba(255, 140, 66, 0.1)

            i
                font-size 24px
                vertical-align middle

            .v-separator
                background-color color-theme(true)
                display inline-block
                width 1px
                height 25px
                margin 0 space-xs
                cursor default

            .orderby
                font-size 1rem

        .slot-content
            padding 0 0 0 space-md
            overflow-x auto

        .select
            width auto
            min-width 150px
            max-width 250px
            border 2px solid accent
            border-radius radius-md
            transition all transition-base

            &:focus
                border-color primary
                box-shadow 0 0 0 3px rgba(255, 140, 66, 0.15)

    // Tablet
    @media (max-width: 991px)
        .interface-content
            padding space-sm

            .interface-header
                padding space-sm

                span
                    font-size 1rem

                i
                    font-size 22px

                .orderby
                    font-size 0.9rem

            .slot-content
                padding 0 0 0 space-sm

    // Mobile
    @media (max-width: 768px)
        .interface-content
            padding space-sm
            border-radius radius-md

            .interface-header
                flex-direction column
                align-items flex-start
                gap space-md
                padding space-sm

                span
                    font-size 0.95rem

                .v-separator
                    display none

                .orderby
                    width 100%
                    margin-top space-xs

            .slot-content
                padding space-xs
                margin 0 (- space-xs)

            .select
                width 100%
                max-width 100%
                margin-top space-xs

    // Small mobile
    @media (max-width: 576px)
        .interface-content
            .interface-header
                .filter
                    width 100%
                    justify-content center

                span
                    font-size 0.9rem

                i
                    font-size 20px

            .slot-content
                padding 0
                overflow-x auto
                -webkit-overflow-scrolling touch

</style>
